import { EditorState } from "draft-js";
import { Attachment } from '@missionlabs/smartagent-service-thread';
import TaskTypes from './tasks.types';
import { ITask } from './tasks.state';

export type TaskAction =
    | { type: typeof TaskTypes.SET_SELECTED_TASK; payload: string | null }
    | { type: typeof TaskTypes.ADD_TASK_CONNECTION; payload: ITask }
    // | { type: typeof TaskTypes.TASK_INCOMING; payload: string }
    | { type: typeof TaskTypes.TASK_CONNECTED; payload: string }
    | { type: typeof TaskTypes.TASK_DISCONNECTED; payload: string }
    | { type: typeof TaskTypes.TASK_ACW; payload: string }
    | { type: typeof TaskTypes.TASK_MISSED; payload: string }
    | { type: typeof TaskTypes.END_TASK; payload: string }
    | { type: typeof TaskTypes.REMOVE_TASK_CONNECTION; payload: string }
    | { type: typeof TaskTypes.CLEAR_TASK_CONNECTION; payload: string }
    | { type: typeof TaskTypes.ACCEPT_TASK; payload: string }
    | { type: typeof TaskTypes.DECLINE_TASK; payload: string }
    | { type: typeof TaskTypes.RECOVER_TASKS; payload: ITask[] }
    | { type: typeof TaskTypes.COMPLETE_TASK_ACW; payload: string }
    | { type: typeof TaskTypes.TRANSFER_TASK; payload: { id: string; endpoint: connect.Endpoint } }
    | { type: typeof TaskTypes.SET_TASK_REPLY_TEXT; payload: { id: string; text: string; isProbablyJson: boolean } }
    | { type: typeof TaskTypes.CLEAR_TASK_REPLY_TEXT; payload: { id: string }}
    | { type: typeof TaskTypes.UPDATE_CONNECTION_EDITOR_CONTENT, payload: { content: EditorState; id: string } }
    | { type: typeof TaskTypes.SEND_TASK_ATTACHMENT; payload: { id:string; }}
    | { type: typeof TaskTypes.SET_TASK_ATTACHMENT; payload: { id: string; attachments: Attachment[]}}
    | { type: typeof TaskTypes.DELETE_TASK_ATTACHMENT; payload: { id: string; index: number }}
    | { type: typeof TaskTypes.SET_INCLUDE_CC_IN_REPLY; payload: { id: string; includeCCInReply: boolean }};

export function completeTaskACW(id: string): TaskAction {
    return {
        type: TaskTypes.COMPLETE_TASK_ACW,
        payload: id,
    };
}

export function setTaskReplyText(id: string, text: string, isProbablyJson: boolean): TaskAction {
    return {
        type: TaskTypes.SET_TASK_REPLY_TEXT,
        payload: {
            id,
            text,
            isProbablyJson
        }
    }
}

export function clearTaskReplyText(id: string): TaskAction {
    return {
        type: TaskTypes.CLEAR_TASK_REPLY_TEXT,
        payload: { id }
    }
}

export function taskMissed(id: string): TaskAction {
    return {
        type: TaskTypes.TASK_MISSED,
        payload: id,
    };
}

export function endTask(id: string): TaskAction {
    return {
        type: TaskTypes.END_TASK,
        payload: id,
    };
}

export function recoverTasks(tasks: ITask[]): TaskAction {
    return {
        type: TaskTypes.RECOVER_TASKS,
        payload: tasks,
    };
}

export function setSelectedTask(id: string | null): TaskAction {
    return {
        type: TaskTypes.SET_SELECTED_TASK,
        payload: id,
    };
}

export function addTaskConnection(task: ITask): TaskAction {
    return {
        type: TaskTypes.ADD_TASK_CONNECTION,
        payload: task,
    };
}

export function taskACW(id: string): TaskAction {
    return {
        type: TaskTypes.TASK_ACW,
        payload: id,
    };
}

export function taskConnected(id: string): TaskAction {
    return {
        type: TaskTypes.TASK_CONNECTED,
        payload: id,
    };
}

export function taskDisconnected(id: string): TaskAction {
    return {
        type: TaskTypes.TASK_DISCONNECTED,
        payload: id,
    };
}

export function removeTaskConnection(id: string): TaskAction {
    return {
        type: TaskTypes.REMOVE_TASK_CONNECTION,
        payload: id,
    };
}
export function clearTaskConnection(id: string): TaskAction {
    return {
        type: TaskTypes.CLEAR_TASK_CONNECTION,
        payload: id,
    };
}

export function acceptTask(id: string): TaskAction {
    return {
        type: TaskTypes.ACCEPT_TASK,
        payload: id,
    };
}

export function declineTask(id: string): TaskAction {
    return {
        type: TaskTypes.DECLINE_TASK,
        payload: id,
    };
}

export function transferTask(id: string, endpoint: connect.Endpoint): TaskAction {
    return {
        type: TaskTypes.TRANSFER_TASK,
        payload: {
            id,
            endpoint,
        },
    };
}

export function updateConnectionEditorContent (id: string, content: EditorState): TaskAction {
    return {
        type: TaskTypes.UPDATE_CONNECTION_EDITOR_CONTENT,
        payload: {
            id,
            content
        }
    }
}

export function sendAttachment(id: string): TaskAction {
    return {
        type: TaskTypes.SEND_TASK_ATTACHMENT,
        payload: {
            id,
        }
    }
}

export function setAttachment(id: string, attachments: Attachment[]): TaskAction {
    return {
        type: TaskTypes.SET_TASK_ATTACHMENT,
        payload: {
            id,
            attachments
        }
    }
}

export function deleteAttachment(id: string, index: number): TaskAction {
    return {
        type: TaskTypes.DELETE_TASK_ATTACHMENT,
        payload: {
            id,
            index
        }
    }
}

export function setIncludeCCInReply(id: string, includeCCInReply: boolean): TaskAction {
    return {
        type: TaskTypes.SET_INCLUDE_CC_IN_REPLY,
        payload: {
            id,
            includeCCInReply
        }
    }
}